<template>
<div>
  <div class="viewarea person_layout vux-flexbox person-center vux-flex-row" style="align-items: flex-start;">
    <div class="layout_left">
      <div class="user_info">
        <div class="user_info_title">
          <img :src="userInfo.headimgurl" alt="">
          <span>{{userInfo.phone}}</span>
        </div>
        <div class="user_edit">
          <div v-for="(v,i) in editInfo" :key="i" class="user_edit_operation" :class="active == i ? 'active' : ''" @click="edit(i)">
            <span :class="v.imgClass"></span>
            <span>{{v.name}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="layout_right">
      <div class="edit_layout" v-if="active==0">
        <div class="edit_layout_title">
          <span class="icon-user" style="color: #08979c"></span>
          <span>个人信息</span>
        </div>
        <!-- <div class="edit_upload" style="margin-top: 40px;margin-bottom: 20px;font-size: 13px;color: #666">
            <div style="float:left;">头像</div>
            <img style="float:left;" :src="userInfo.headimgurl" alt="" class="headimgurl">
            <button class="imgBtn">更换头像</button>
        </div> -->
        <div class="mt20" style="clear: both"></div>
        <el-form ref="personinfo" inline-message :model="personinfo" size="small" :rules="rules"
                 :label-position="labelPosition">
          <el-form-item label="用户名" label-width="100px">
            <el-input v-model="personinfo.username" :disabled="true" size="small"></el-input>
          </el-form-item>
          <el-form-item label="手机号" label-width="100px">
            <el-input v-model="personinfo.phone" name="phone" prop="phone"  auto-complete="new-password"  autocomplete="off" ></el-input>
          </el-form-item>
          <el-form-item label="角色" prop="rolecode" label-width="100px">
            <el-select v-model="personinfo.rolecode" multiple placeholder="请选择" :disabled="true"
                       style="width: 100%" value-key="item.id">
              <el-option v-for="(item,index) in selectData" :key="index" :value="item.code"
                         :label="item.name"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="电子邮箱" prop="email" label-width="100px">
            <el-input v-model="personinfo.email"></el-input>
          </el-form-item>
          <el-form-item label="工号" prop="worknumber" label-width="100px">
            <el-input v-model="personinfo.worknumber"></el-input>
          </el-form-item>

          <el-form-item label="身份证号" prop="idnumber" label-width="100px">
            <el-input v-model="personinfo.idnumber"></el-input>
          </el-form-item>
          <el-form-item label="职务" prop="post" label-width="100px">
            <el-input v-model="personinfo.post"></el-input>
          </el-form-item>

          <el-form-item label="性别" label-width="100px">
            <el-radio-group v-model="personinfo.sex">
              <el-radio :label="1">男</el-radio>
              <el-radio :label="0">女</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="允许授权" prop="ispermit" label-width="100px">
            <el-radio-group v-model="personinfo.ispermit" :disabled="true">
              <el-radio label="1">是</el-radio>
              <el-radio label="2">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="允许登录" prop="islogin" label-width="100px">
            <el-radio-group v-model="personinfo.islogin" :disabled="true">
              <el-radio label="1">是</el-radio>
              <el-radio label="2">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
          <el-button style="margin-left: 100px;width: 376px;background: #2fa5e5;border-color:#08979c;color:#fff " @click="submitForm('personinfo')">保存</el-button>
      </div>
      <div class="edit_layout" v-if="active==1">
        <div class="edit_layout_title" style="margin-bottom: 40px">
          <span class="icon-lock" style="color: #08979c"></span>
          <span>账号密码</span>
        </div>
        <el-form inline-message :model="passwordedit" status-icon :rules="pasRules" ref="passwordedit"
                 label-width="100px" class="demo-ruleForm" :label-position="labelPosition" size="small">
          <el-form-item label="当前用户" prop="username">
            <el-input v-model.number="passwordedit.username" disabled></el-input>
          </el-form-item>
          <el-form-item label="原始密码" prop="oldpassword">
            <el-input type="password" name="oldpassword" auto-complete="new-password" v-model.number="passwordedit.oldpassword" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="密码 " prop="newpassword">
            <el-input type="password" name="newpassword" auto-complete="new-password"  v-model="passwordedit.newpassword" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="checkPassword">
            <el-input type="password" name="checkPassword" auto-complete="new-password" v-model="passwordedit.checkPassword" autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
        <el-button style="margin-left: 100px;width: 376px;background: #2fa5e5;border-color:#08979c;color:#fff " @click="submitForm('passwordedit')">保存</el-button>
      </div>
    </div>
</div>
</div>
</template>

<script>

    export default {
        name: "personinfo",
        data(){
          return{
            file_url: Config.dev_url,
            basic_url: Config.dev_url,
            active:0,
            selectData:"",
            userInfo:this.$store.state.currentuser,
            editInfo:[
              {name:"个人信息",imgClass:"icon-user"},
              {name:"账号密码",imgClass:"icon-lock"},
            ],
            headimgurl:"",
            labelPosition: 'left',
            personinfo: {
              worknumber: '',//工号
              username: '',//用户名
              password: '',//密码
              nickname: '',//人员姓名
              user_active_date: '',//用户有效期
              islogin: '',//是否允许登录
              ispermit: '',//是否允许授权
              deptId: '',//所属组织ID
              deptName: '',//所属组织名称
              companyName: '',//所属组织
              enabled: '',//配置信息状态
              enabledName: '',//配置信息状态名称
              birthday: '',//出生日期
              sex: '',//性别
              idnumber: '',//身份证号
              rolecode: [],//角色ID
              roles: [],//角色
              traings: [],
              qualifications: [],
              ips: [],
              entrytime: '',//入职日
              email: '',//邮箱
              phone: '',//手机
              address: '',//地址
              tips: '',//备注
              telephone: '',//联系电话
              zipcode: '',//邮编
              ipaddress: '',//IP地址
              macaddress: '',//MAC地址
              erp_orgname: '',//ERP机构
              education: '',//最高学历
              //logintype: [],//登录方式
              //rex:'',//传真号
              //orders:'',//排序号
              //workdate:'',//参加工作时间
            },
            resourceData: [], //数组，我这里是通过接口获取数据，
            resourceDialogisShow: false,
            resourceCheckedKey: [], //通过接口获取的需要默认展示的数组 [1,3,15,18,...]
            resourceProps: {
              children: "subDepts",
              label: "fullname"
            },
            docParm: {},
            passwordedit: {
              username: '',
              oldpassword: '',//原始密码
              newpassword: '',//新密码
              checkPassword: ''//确认新密码
            },
            pasRules: {
              oldpassword: [
                {required: true, trigger: 'blur', message: '必填'},
                // {validator: this.Validators.isCheckOldpassword, trigger: 'blur'},
              ],
              newpassword: [
                {required: true, trigger: 'blur', message: '必填'},
                {validator: this.Validators.isValidatePass, trigger: 'blur'},
              ],
              checkPassword: [
                {required: true, trigger: 'blur', message: '必填'},
                {validator: this.Validators.isValidatePass, trigger: 'blur'},
              ]
            },
            rules: {//required: true,必填标题加红*
              rolecode: [{required: true, trigger: 'blur', message: '必填',}],
              nickname: [{required: true, trigger: 'blur', validator: this.Validators.isNickname}],
              worknumber: [
                {required: true, trigger: 'blur', message: '必填'},
                {validator: this.Validators.isWorknumber, trigger: 'blur'},//引用 isWorknumber
              ],
              email: [
                {required: true, trigger: 'blur', message: '必填'},
                {validator: this.Validators.isEmail, trigger: 'blur'},
              ],
              telephone: [{required: false, trigger: 'blur', validator: this.Validators.isTelephone}],
              phone: [
                {required: true, trigger: 'blur', message: '必填'},
                {validator: this.Validators.isPhone, trigger: 'blur'},
              ],
              idnumber: [{required: false, trigger: 'blur', validator: this.Validators.isIdnumber}],
              address: [{required: false, trigger: 'blur', validator: this.Validators.isSpecificKey}],
              zipcode: [{required: false, trigger: 'blur', validator: this.Validators.isZipcode}],
              ipaddress: [{required: false, trigger: 'blur', validator: this.Validators.isIpaddress}],
              macaddress: [{required: false, trigger: 'blur', validator: this.Validators.isMacaddress}],
              post: [{required: false, trigger: 'blur', validator: this.Validators.isSpecificKey}],
              tips: [{required: false, trigger: 'blur', validator: this.Validators.isSpecificKey}],
            },
          }
        },
      methods:{
        edit(i){
          this.active = i;
          console.log(this.personinfo)
        },
        upload(e) {
          var formData = new FormData();
          this.loading = true;
          this.$emit('showLoading');
          formData.append('files', document.getElementById('excelFile').files[0]);
          var config = {
            //添加请求头
            headers: {"Content-Type": "multipart/form-data"},
            //添加上传进度监听事件
            onUploadProgress: e => {
              var completeProgress = ((e.loaded / e.total * 100) | 0) + "%";
              this.progress = completeProgress;
            }
          };
          var url = this.file_url + '/file-center/file/uploadIcon?userid=' + this.docParm.userid
            + '&username=' + this.docParm.username
            + '&deptid=' + this.docParm.deptid
            + '&deptfullname=' + this.docParm.deptfullname
            + '&recordid=1&appname=icon&appid=99&pathid=5';
          if (this.headimgurl != '') {
            url += '&fileid=' + this.fileid;
          }
          console.log(url)
          this.$axios.post(url, formData, config
          ).then((res) => {
            this.loading = false;
            if (res.data.code == 0) {
              this.$message({
                message: res.data.message,
                type: 'error'
              });
            } else {
              this.$message({
                message: '文件已成功上传至服务器',
                type: 'success'
              });
              this.headimgurl = res.data.icon;
            }
          }).catch((err) => {
                });
        },
        deepClone(obj){
            // 先检测是不是数组和Object
            // let isArr = Object.prototype.toString.call(obj) === '[object Array]';
            let isArr = Array.isArray(obj);
            let isJson = Object.prototype.toString.call(obj) === '[object Object]';
            if (isArr) {
              // 克隆数组
              let newObj = [];
              for (let i = 0; i < obj.length; i++) {
                newObj[i] = this.deepClone(obj[i]);
              }
              return newObj;
            } else if (isJson) {
              // 克隆Object
              let newObj = {};
              for (let i in obj) {
                newObj[i] = this.deepClone(obj[i]);
              }
              return newObj;
            }
            // 不是引用类型直接返回
            return obj;
        },
        submitForm(formName) {//修改当前用户信息
          if(formName == "personinfo"){
            this.$refs[formName].validate((valid) => {
              if (valid) {
                var url = this.basic_url + '/api-user/users/me';
                var personinfo = this.deepClone(this.personinfo);
                personinfo.rolecode = personinfo.rolecode.join(",")
                console.log(personinfo)
                this.$axios.put(url, personinfo).then((res) => {
                  if (res.data.code == 0) {
                    this.$message({
                      message: '保存成功',
                      type: 'success'
                    });
                  }
                }).catch((err) => {
                });

              } else {
                return false;
              }
            });
          }else if(formName == "passwordedit"){
            this.$refs[formName].validate((valid) => {
              if (valid) {
                var userid = this.passwordedit.id;
                var oldpassword = this.passwordedit.oldpassword;
                var newpassword = this.passwordedit.newpassword;
                var checkPassword = this.passwordedit.checkPassword;
                if (newpassword == checkPassword) {
                  var url = Config.dev_url + '/api-user/users/password';
                  this.$axios.put(url, {
                    id: userid,
                    oldPassword: oldpassword,
                    newPassword: newpassword
                  }).then((res) => {
                    if (res.data.resp_code == 0) {//resp_code == 0是后台返回的请求成功的信息
                      this.$message({
                        message: '修改成功',
                        type: 'success'
                      });
                    } else {
                      if (res.data.resp_code == 1) {
                        this.$message({
                          message: res.data.resp_msg,
                          type: 'error'
                        });
                      }
                    }
                  }).catch((err) => {
                });
                } else {
                  this.$message({
                    message: '密码与确认密码不一致，请重新填写',
                    type: 'error'
                  });
                }
              } else {
                return false;
              }
            });
          }

        },
        getData() {//获取当前用户信息
          var url = Config.dev_url + '/api-user/users/currentMap';
          this.$axios.get(url, {}).then((res) => {
            this.personinfo = res.data;
            console.log(this.personinfo)
            var roles = res.data.roles;
            this.docParm.userid = res.data.id;
            this.docParm.username = res.data.username;
            this.docParm.deptid = res.data.deptid;
            this.docParm.deptfullname = res.data.deptName;
            this.personinfo.rolecode =  this.personinfo.rolecode ? this.personinfo.rolecode.split(',') : [];
            this.passwordedit.username = res.data.username;
            this.passwordedit.id = res.data.id;
            // var arr = [];
            // var rolecode = this.personinfo.rolecode;
            // for (var i = 0; i < rolecode.length; i++) {
            //   rolecode[i] = parseInt(rolecode[i]);
            // }
            console.log(1111)
            this.getImgUrl();
          }).catch((err) => {
          });
        },
        getImgUrl() {//用户头像
          var url = this.file_url + '/file-center/file/icon?appname=icon&userid=' + this.docParm.userid;
          this.$axios.get(url, {}).then((res) => {
            if (res.data.code == 1) {
              this.headimgurl = res.data.icon;
              this.fileid = res.data.fileid;
            } else {
              this.headimgurl = '';
              this.fileid = 0;
            }
          }).catch((err) => {
                });
        },
        getDept() {//所属机构
          this.editSearch = 'dept';
          var url = Config.dev_url + '/api-user/depts/treeMap';
          this.$axios.get(url, {}).then((res) => {
            //
            this.resourceData = res.data.data;
            this.dialogVisible = true;
          }).catch((err) => {
                });
        },

        //角色
        getRole() {
          var url = Config.dev_url + '/api-user/roles';
          this.$axios.get(url, {}).then((res) => {
            this.selectData = res.data.data;
            console.log(this.selectData)
            this.selectData.forEach((item)=>{
                console.log(item.code)
            })
          }).catch(error => {
          })
        },
      },
      mounted() {
        this.getRole();
        this.getData();
      },
    }
</script>

<style scoped>
  .person_layout{
    width: 70%;
    margin: 0 auto;
    overflow: auto;
    /* overflow-x: hidden; */
  }
  .vux-flex-row {
    box-direction: row;
    box-orient: horizontal;
    -webkit-box-orient: horizontal;
    -ms-flex-direction: row;
    flex-direction: row;
  }

  element.style {
    align-items: flex-start;
  }
  .person-center[data-v-118b6478] {
    width: 1180px;
    margin: 0 auto;
  }
  .vux-flex-col, .vux-flex-row {
    -webkit-box-direction: normal;
  }
  .vux-flex-row {
    box-direction: row;
    box-orient: horizontal;
    -webkit-box-orient: horizontal;
    -ms-flex-direction: row;
    flex-direction: row;
  }
  .vux-flexbox {
    /*width: 100%;*/
    text-align: left;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    display: -webkit-flex;
    box-align: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }
  .layout_left{
    width: 300px;
    background-color: #fff;
    padding-bottom: 100px;
    border: 1px solid #e6e6e6;
    border-radius: 4px;
    margin-right: 20px;
  }
  .layout_right{
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    border: 1px solid #e6e6e6;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    padding: 22px 25px;
  }
  .user_info_title{
    width: 100%;
    text-align: center;
    padding: 20px
  }
  .user_edit_operation{
    width: 100%;
    padding: 20px 0;
    text-indent: 20px;
    cursor: pointer;
    font-size: 14px;
  }
  .user_edit_operation span:last-child{
    padding-left: 5px;
  }
  .active{
    color: #333;
    background-color: #f1f5f8;
  }
  .edit_layout_title{
    font-weight: bold;
    font-size: 16px;
  }
  .edit_layout_title span:last-child{
    padding-left: 20px;
  }
  /deep/ .el-input{
    width: 376px !important;
  }
  /deep/ .el-form-item__label{
    font-size: 13px;
  }
  /deep/ .el-form-item{
    margin-bottom: 18px !important;
  }
  .imgBtn{
    outline: none;
    border: none;
    font-size: 12px;
    line-height: 1;
    color: #08979c;
    border: 1px solid #08979c;
    border-radius: 4px;
    padding: 8px;
    cursor: pointer;
    background: #fff;
    margin: 20px 0 20px 50px;
  }
  .headimgurl{
      width: 70px;
      height: 70px;
      border-radius: 50%;
      background: skyblue;
      margin-left: 80px;
  }
</style>
